// @flow
import type {Element} from 'react'
import React from 'react'
import classNames from 'classnames'

import type {Callback} from 'components/types'

type Props = {
  onClick: Callback,
  className?: string,
}

function CloseButton({onClick, className = ''}: Props): Element<"button"> {
  const buttonClass = classNames(
    'btn-reset banner__close test-banner-close',
    className,
  )

  return (
    <button
      aria-label={I18n.t('buttons.close')}
      onClick={onClick}
      className={buttonClass}
      type="button"
      title={I18n.t('buttons.close')}
    >
      <i className="fa-solid fa-xmark" aria-hidden="true" />
    </button>
  )
}

export default CloseButton
